import { render, staticRenderFns } from "./VirtualMenuSettings.vue?vue&type=template&id=b7c78b06&"
import script from "./VirtualMenuSettings.vue?vue&type=script&lang=js&"
export * from "./VirtualMenuSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports